define("shared/components/shared/date-picker", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "moment", "@ember/template-factory"], function (_exports, _component, _service, _component2, _moment, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"moment",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::BaseTimePicker @config={{this.rawFlatpickrConfig}} @inputClass={{@inputClass}} @placeholder={{@placeholder}}>
  
    <:beforeInput as |pickerId|>
      <label class="o--inputAction__icon--left u--flex u--flex__alignItems--center" for={{pickerId}}>
        {{svg-jar "calendar" class="o--icon"}}
      </label>
    </:beforeInput>
  
  </Shared::BaseTimePicker>
  */
  {
    "id": "F1u/eXK3",
    "block": "[[[8,[39,0],null,[[\"@config\",\"@inputClass\",\"@placeholder\"],[[30,0,[\"rawFlatpickrConfig\"]],[30,1],[30,2]]],[[\"beforeInput\"],[[[[1,\"\\n    \"],[10,\"label\"],[14,0,\"o--inputAction__icon--left u--flex u--flex__alignItems--center\"],[15,\"for\",[30,3]],[12],[1,\"\\n      \"],[1,[28,[35,1],[\"calendar\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[3]]]]]],[\"@inputClass\",\"@placeholder\",\"pickerId\"],false,[\"shared/base-time-picker\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/date-picker.hbs",
    "isStrictMode": false
  });
  let DatePickerComponent = _exports.default = (_class = class DatePickerComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "userConfig", _descriptor, this);
      _defineProperty(this, "onValueUpdate", selectedDates => {
        const selectedDate = (0, _moment.default)(selectedDates[0]).tz(this.timezoneIdentifier, true);
        if (typeof this.args.onDateChange === 'function') {
          this.args.onDateChange(selectedDate);
        }
      });
    }
    get timezoneIdentifier() {
      return this.userConfig.currentTimeZone.identifier;
    }
    get flatpickrDefaults() {
      return {
        altInput: true,
        allowInput: true,
        clickOpens: false,
        wrap: true
      };
    }
    get rawFlatpickrConfig() {
      const {
        dateTime,
        dateFormat = 'M j, Y',
        onDateChange,
        ...rest
      } = this.args;
      return {
        ...this.flatpickrDefaults,
        dateTime,
        dateFormat,
        onDateChange,
        onValueUpdate: this.onValueUpdate,
        defaultDate: 'no-default',
        ...rest
      };
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "userConfig", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, DatePickerComponent);
});